<header>
  <span [routerLink]="['../']" [queryParams]="{ taxYear: taxYear() }">{{
    "settings.back-to-all-questions" | transloco
  }}</span>

  <div>
    <h2 *transloco="let t">
      @if (!isProductionMode) {
      <span>{{
        question?.id ? t("settings.edit") : t("settings.create")
      }}</span>
      }
      {{ "settings.question" | transloco }}
      <span id="question-yr">({{ yearLabel }} {{ question?.year }})</span>
    </h2>

    <!-- TRANSLOCO TODO -->
    <div class="actions">
      @if (showDelete && question?.id) {
      <div>
        <div class="ui basic button" (click)="deleteQuestion(question)">
          {{ isDeletedQuestion ? "RESTORE" : "DELETE" }}
        </div>
      </div>
      }
    </div>
    <!-- END OF TRANSLOCO TODO -->

    <div class="actions">
      @if (!isProductionMode) {
      <div
        (click)="save()"
        [ngClass]="{
          loading: isSaving,
          disabled: !formGroup?.valid || isSaving
        }"
        class="ui primary button"
      >
        {{ "settings.save" | transloco }}
      </div>
      }
    </div>
  </div>

  <div id="tabs-menu" class="no-select">
    <div (click)="goToTab(1)" class="tab" [ngClass]="{ active: tab === 1 }">
      {{ "settings.question-uppercase" | transloco }}
    </div>
    <div (click)="goToTab(2)" class="tab" [ngClass]="{ active: tab === 2 }">
      {{ "settings.values-uppercase" | transloco }}
    </div>
    <div (click)="goToTab(3)" class="tab" [ngClass]="{ active: tab === 3 }">
      {{ "settings.dependencies" | transloco }}
    </div>
    @if (questionType?.value === 'table') {
    <div (click)="goToTab(4)" class="tab" [ngClass]="{ active: tab === 4 }">
      {{ "settings.table" | transloco }}
    </div>
    }
  </div>
</header>

@if (question) {
<div id="body">
  <div [hidden]="tab !== 1" id="question" class="tab">
    <div class="settings-fields">
      <div
        [ngClass]="{ disabled: question?.id && questionType.value === 'table' }"
      >
        <label>{{ "settings.question-type" | transloco }}</label>
        <div class="ui search selection dropdown" #questionTypeDropDown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
        <input type="hidden" [formControl]="questionType" />
      </div>
      <div>
        <label>{{ "settings.question" | transloco }}</label>
        <input type="text" [formControl]="questionName" />
      </div>
      <div class="ui equal width grid">
        <div
          class="column"
          [ngClass]="{
            disabled:
              questionType.value === 'checkbox' ||
              questionType.value === 'table'
          }"
        >
          <label>{{ "settings.mandatory" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="mandatory"
                type="radio"
                name="mandatory"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="mandatory"
                type="radio"
                name="mandatory"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
        <div class="column">
          <label>{{ "settings.hidden" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="hidden"
                type="radio"
                name="hidden"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="hidden"
                type="radio"
                name="hidden"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
      </div>
      @if ( questionType.value !== 'drop down' && questionType.value !== 'radio'
      && questionType.value !== 'radio' && questionType.value !== 'checkbox' ) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.default-value" | transloco }}</label>
        @if (questionType.value !== 'number') {
        <input type="text" [formControl]="default" />
        } @if (questionType.value === 'number') {
        <input type="number" [formControl]="default" />
        }
      </div>
      } @if (questionType.value == 'checkbox') {
      <div>
        <div>
          <label>{{ "settings.default-value" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="default"
                type="radio"
                name="default"
                [value]="'true'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.checked" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="default"
                type="radio"
                name="default"
                [value]="'false'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.unchecked" | transloco
              }}</span>
            </label>
          </div>
        </div>
      </div>
      }
      <div
        [hidden]="
          questionType.value !== 'drop down' && questionType.value !== 'radio'
        "
        [ngClass]="{ disabled: questionType.value === 'table' }"
      >
        <label>{{ "settings.default-value" | transloco }}</label>
        <div class="ui search selection dropdown" #defaultValueDropdown>
          <input class="search" />
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
      <div
        [ngClass]="{
          disabled:
            questionType.value !== 'number' || questionType.value === 'table'
        }"
      >
        <label>{{ "settings.min-value" | transloco }}</label>
        <input type="number" [formControl]="min" />
      </div>
      <div
        [ngClass]="{
          disabled:
            questionType.value !== 'number' || questionType.value === 'table'
        }"
      >
        <label>{{ "settings.max-value" | transloco }}</label>
        <input type="number" [formControl]="max" />
      </div>
      <div
        [ngClass]="{
          disabled:
            (questionType.value !== 'text' &&
              questionType.value !== 'number' &&
              questionType.value !== 'textarea') ||
            questionType.value === 'table'
        }"
      >
        <label>{{ "settings.max-characters" | transloco }}</label>
        <input type="number" min="0" [formControl]="maxLength" />
      </div>
      <div
        [ngClass]="{
          disabled:
            questionType.value !== 'number' || questionType.value === 'table'
        }"
      >
        <label>{{ "settings.number-options" | transloco }}</label>
        <div class="ui search selection dropdown" #numberOptionsDropDown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
      <div
        [ngClass]="{
          disabled:
            questionType.value === 'table' || questionType.value !== 'number'
        }"
      >
        <label>{{ "settings.allow-decimals" | transloco }}</label>
        <div class="container">
          <label>
            <input
              [formControl]="allowDecimals"
              type="radio"
              name="allowDecimals"
              [value]="true"
            />
            <span class="checkmark"></span>
            <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
          </label>
        </div>
        <div class="container">
          <label>
            <input
              [formControl]="allowDecimals"
              type="radio"
              name="allowDecimals"
              [value]="false"
            />
            <span class="checkmark"></span>
            <span class="lbl-text">{{ "settings.no" | transloco }}</span>
          </label>
        </div>
      </div>
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.value-format" | transloco }}</label>
        <input type="text" [formControl]="valueFormat" />
      </div>
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.hint" | transloco }}</label>
        <input type="text" [formControl]="clientHint" />
      </div>
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.tag" | transloco }}</label>
        <input type="text" [formControl]="tag" />
      </div>
      <div class="ui equal width grid">
        <div
          class="column"
          [ngClass]="{ disabled: questionType.value === 'table' }"
        >
          <label>{{ "settings.allow-filtering" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="filtering"
                type="radio"
                name="filtering"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="filtering"
                type="radio"
                name="filtering"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="tab !== 2" class="tab" id="values">
    @if ( questionType.value !== 'drop down' && questionType.value !== 'radio' )
    {
    <div>
      <h4>
        {{
          "settings.not-allow-preset-values"
            | transloco: { value: questionType.value }
        }}
      </h4>
      {{ "settings.preset-values" | transloco }}
      <strong>{{ "settings.drop-down" | transloco }}</strong>
      {{ "settings.or" | transloco }}
      <strong>{{ "settings.radio" | transloco }}</strong>
      {{ "settings.questions-lowercase" | transloco }}.
    </div>
    } @if (questionType.value == 'drop down' || questionType.value == 'radio') {
    <div>
      <div class="header-box">
        <h4>{{ "settings.example" | transloco }}</h4>
        <p>
          {{
            "settings.for-the-question-is-this-person-an-australian-citizen-your-values-would-be-yes-and-no-and-each-value-has-a-code-which-is-what-actually-pushes-to-aps-to-go-on-the-return"
              | transloco
          }}
        </p>
        <div>
          <div class="row">{{ "settings.yes" | transloco }}</div>
          <div class="row">{{ "settings.y" | transloco }}</div>
        </div>
        <div>
          <div class="row">{{ "settings.no" | transloco }}</div>
          <div class="row">{{ "settings.n" | transloco }}</div>
        </div>
      </div>
      <div id="values-header">
        <h3>{{ "settings.values" | transloco }}</h3>
        @if (!isProductionMode) {
        <div (click)="addValue()" class="new-value-btn">
          {{ "settings.new-value" | transloco }}
        </div>
        }
      </div>
      <div id="tbl-container">
        <table cellspacing="0" cellpadding="0" width="100%">
          <thead>
            <tr>
              <td style="width: 15em">{{ "settings.display" | transloco }}</td>
              <td style="width: 15em">{{ "settings.value" | transloco }}</td>
              <td style="width: 8em">
                {{ "settings.display-order" | transloco }}
              </td>
              <td style="width: 10em">
                {{ "settings.default-selected" | transloco }}
              </td>
              <td style="width: 8em">{{ "settings.disabled" | transloco }}</td>
              @if (!isProductionMode) {
              <td></td>
              }
            </tr>
          </thead>
          <tbody>
            @for ( valueOption of question.questionDropdowns; track valueOption;
            let index = $index) { @if (valueOption.status !== 99) {
            <tr [ngClass]="{ active: valueOption.edit }">
              <td (click)="editValue(valueOption, $event)">
                <input
                  type="text"
                  [(ngModel)]="valueOption.display"
                  (change)="initDefaultValueDropdown(); updatePreview()"
                />
              </td>
              <td (click)="editValue(valueOption, $event)">
                <input
                  type="text"
                  [(ngModel)]="valueOption.value"
                  (change)="initDefaultValueDropdown(); updatePreview()"
                />
              </td>
              <td (click)="editValue(valueOption, $event)">
                <input
                  type="text"
                  [(ngModel)]="valueOption.order"
                  (change)="initDefaultValueDropdown(); updatePreview()"
                />
              </td>
              <td>
                <div class="ui checkbox" [hidden]="valueOption.disabled">
                  <input
                    type="checkbox"
                    [checked]="valueOption.selected"
                    (change)="toggleDefaultValue(valueOption); updatePreview()"
                  />
                </div>
              </td>
              <td>
                <div class="ui checkbox">
                  <input
                    type="checkbox"
                    [(ngModel)]="valueOption.disabled"
                    (change)="initDefaultValueDropdown(); updatePreview()"
                  />
                </div>
              </td>
              @if (!isProductionMode) {
              <td>
                @if (!valueOption.selected) {
                <div (click)="deleteValue(index)" class="delete icon"></div>
                }
              </td>
              }
            </tr>
            } }
          </tbody>
        </table>
      </div>
    </div>
    }
  </div>
  <div [hidden]="tab !== 3" class="tab" id="dependencies">
    @if ( questionType.value === 'checkbox' || questionType.value === 'table' )
    {
    <div>
      <h4>
        {{
          "settings.you-cannot-set-dependencies-for-question-type-value-questions"
            | transloco: { value: questionType.value }
        }}
      </h4>
    </div>
    }
    <div
      [hidden]="
        questionType.value == 'checkbox' || questionType.value == 'table'
      "
    >
      <div class="header-box">
        <h4>{{ "settings.dependencies" | transloco }}</h4>
        <p>
          {{
            "settings.if-this-question-depends-on-the-answer-of-another-question-use-these-settings-to-define-the-questions-that-it-is-dependant-on-and-the-respective-behaviour-that-depend-on-the-parent-question"
              | transloco
          }}
        </p>
      </div>
      <h5>
        {{
          "settings.question-question-will-become-mandatory-when"
            | transloco: { question: question?.question }
        }}
      </h5>
      <div class="settings-fields">
        <div>
          <label>{{ "settings.another-question" | transloco }}</label>
          <div class="ui search selection dropdown" #depMandQuestionDropDown>
            <input class="search" />
            <div class="text"></div>
            <div class="menu"></div>
            <i class="chevron down icon"></i>
          </div>
        </div>
        <div [hidden]="!question.dependantMandatoryParentId">
          <label>{{ "settings.has" | transloco }}</label>
          <div class="container">
            <label
              (click)="
                question.dependantMandatoryParentValue = null;
                initDepAnsDropdown()
              "
            >
              <input
                [(ngModel)]="dependencyType"
                type="radio"
                name="dependencyType"
                [value]="'any'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.any-answer" | transloco
              }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [(ngModel)]="dependencyType"
                type="radio"
                name="dependencyType"
                [value]="'specific'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.a-specific-answer" | transloco
              }}</span>
            </label>
          </div>
        </div>
        @if (dependantMandatoryQuestion) {
        <div
          [ngClass]="{
            disabled:
              dependencyType !== 'specific' ||
              !question.dependantMandatoryParentId
          }"
        >
          <label>{{
            "settings.select-specific-value-answer" | transloco
          }}</label>
          @if ( (dependantMandatoryQuestion.displayFieldType === 'text' ||
          dependantMandatoryQuestion.displayFieldType === 'textarea' ||
          dependantMandatoryQuestion.displayFieldType === 'date picker') &&
          dependantMandatoryQuestion.dataType.toLowerCase() === 'string' ) {
          <input
            type="text"
            [(ngModel)]="question.dependantMandatoryParentValue"
          />
          } @if ( dependantMandatoryQuestion.displayFieldType === 'text' &&
          (dependantMandatoryQuestion.dataType.toLowerCase() === 'integer' ||
          dependantMandatoryQuestion.dataType.toLowerCase() === 'float') ) {
          <input
            type="number"
            max="question.max"
            [(ngModel)]="question.dependantMandatoryParentValue"
          />
          }
          <div
            [hidden]="
              dependantMandatoryQuestion.displayFieldType !== 'drop down' &&
              dependantMandatoryQuestion.displayFieldType !== 'radio'
            "
            class="ui search selection dropdown"
            #depMandAnswerDropdown
          >
            <input class="search" />
            <div class="text"></div>
            <div class="menu"></div>
            <i class="chevron down icon"></i>
          </div>
          <div
            [hidden]="
              dependantMandatoryQuestion.displayFieldType !== 'checkbox'
            "
          >
            <div class="container">
              <label>
                <input
                  [(ngModel)]="question.dependantMandatoryParentValue"
                  type="radio"
                  name="dependantMandatoryParentValue"
                  [value]="'true'"
                />
                <span class="checkmark"></span>
                <span class="lbl-text">{{ "settings.true" | transloco }}</span>
              </label>
            </div>
            <div class="container">
              <label>
                <input
                  [(ngModel)]="question.dependantMandatoryParentValue"
                  type="radio"
                  name="dependantMandatoryParentValue"
                  [value]="'false'"
                />
                <span class="checkmark"></span>
                <span class="lbl-text">{{ "settings.false" | transloco }}</span>
              </label>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  <div [hidden]="tab !== 4" class="tab" id="table">
    <div [hidden]="questionType.value !== 'table'" id="table-questions">
      <h2>{{ "settings.table-columns" | transloco }}</h2>
      <div class="table-container">
        <table cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              @for (_question of columnQuestions; track _question) {
              <td>
                {{ _question?.question }}
                @if (_question.parentId !== question.id) {
                <div
                  (click)="removeQuestion(_question)"
                  class="delete icon"
                  title="Remove question"
                ></div>
                }
              </td>
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              @for (_question of columnQuestions; track _question) {
              <td>
                {{ _question?.displayFieldType }}
              </td>
              }
            </tr>
          </tbody>
        </table>
      </div>
      @if (!isProductionMode) {
      <span (click)="addExistingQuestion()" class="new-value-btn">{{
        "settings.add-column" | transloco
      }}</span>
      }
    </div>
  </div>
  <div
    id="preview"
    [ngClass]="{
      'no-overflow':
        questionType.value === 'drop down' ||
        questionType.value === 'date picker'
    }"
  >
    @if (questionType.value !== 'table') {
    <div>
      <h2>{{ "settings.question-preview" | transloco }}</h2>
      @if (prevFormGroup.controls[question.id]) {
      <app-form-field-wrapper
        [formGroup]="prevFormGroup"
        [question]="question"
      ></app-form-field-wrapper>
      }
      <div [hidden]="prevFormGroup.controls[question.id]" class="loading">
        <div class="ui active centered inline loader"></div>
      </div>
    </div>
    } @if (questionType.value === 'table') {
    <div>
      <h4>
        {{
          "settings.preview-is-not-available-for-table-questions" | transloco
        }}
      </h4>
    </div>
    }
  </div>
</div>
}

<div class="ui huge modal" id="add-question-modal" #addQuestionModal>
  <div class="icon modal-close close"></div>

  <h2>{{ "settings.add-question" | transloco }}</h2>
  <div id="filters">
    <div id="keyword-filter">
      <div class="ui left icon fluid input">
        <i class="search icon"></i>
        <input
          type="text"
          [(ngModel)]="questionSearch"
          placeholder="Search Questions"
        />
      </div>
    </div>
  </div>

  <div class="table-container">
    <table width="100%" cellspacing="0">
      <thead>
        <tr>
          <td width="500px">{{ "settings.question" | transloco }}</td>
          <td width="200px" class="no-wrap">
            {{ "settings.type-of-field" | transloco }}
          </td>
          <td width="200px" class="no-wrap">
            {{ "settings.mandatory" | transloco }}
          </td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        @for ( question of questions | keyWord: ['question',
        'APSRef']:questionSearch ; track question) { @if
        (canAddTableQuestion(question)) {
        <tr>
          <td>{{ question?.question }}</td>
          <td>{{ question?.displayFieldType }}</td>
          <td>{{ question?.mandatory ? "Yes" : "No" }}</td>
          <td (click)="useQuestion(question)" align="right" class="use-btn">
            <strong>{{ "settings.use" | transloco }}</strong>
          </td>
        </tr>
        } }
      </tbody>
    </table>
  </div>
</div>
